module.exports = __webpack_public_path__ + "static/media/tl.fe273366.svg";